/* ============================================================
   ESTADO DE LA EDICIÓN — el ÚNICO sitio que hay que tocar.
   Pon en "vendidas" el número real de unidades vendidas.
   Cuando conectes la tienda, sustituye este objeto por el dato
   que devuelva tu pasarela (Shopify, Stripe...).
   ============================================================ */

(function(){
  /* El contador dice el stock real: inventario menos lo vendido fuera.
     Se anima al entrar en pantalla y vuelve a consultarse cuando el
     visitante regresa a la pestaña, para que la cifra esté viva de verdad
     y no simplemente parezca que lo está. */
  var linea = document.getElementById('stock-line');
  var cifra = document.getElementById('stock-left');
  var tot   = document.getElementById('stock-total');
  var caja  = document.querySelector('.stockbox');
  var cont  = cifra ? cifra.parentNode : null;
  var bar   = document.getElementById('bar');
  if (!linea || !cifra || !caja) return;

  var TOTAL  = EDICION.total;
  var quedan = Math.max(0, TOTAL - EDICION.vendidas);
  var quieto = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;

  tot.textContent = '/' + TOTAL;

  function estado(n){
    var fin = n === 0;
    if (fin) {
      linea.setAttribute('data-es','EDICIÓN AGOTADA');
      linea.setAttribute('data-en','SOLD OUT');
    } else {
      linea.setAttribute('data-es','UNIDADES DISPONIBLES');
      linea.setAttribute('data-en','UNITS AVAILABLE');
    }
    linea.classList.toggle('hot', fin);
    if (cont) cont.classList.toggle('hot', fin);
    if (bar)  bar.classList.toggle('hot', fin);
    linea.textContent = linea.getAttribute('data-' + (document.documentElement.lang || 'es'));
  }

  function barra(n){
    if (bar) bar.firstElementChild.style.width = (n / TOTAL * 100).toFixed(1) + '%';
  }

  var anim;
  function contar(desde, hasta, ms){
    cancelAnimationFrame(anim);
    if (quieto || ms === 0) { cifra.textContent = hasta; barra(hasta); return; }
    var t0 = null;
    (function paso(t){
      if (t0 === null) t0 = t;
      var k = Math.min(1, (t - t0) / ms);
      var e = 1 - Math.pow(1 - k, 3);
      cifra.textContent = Math.round(desde + (hasta - desde) * e);
      if (k < 1) anim = requestAnimationFrame(paso); else cifra.textContent = hasta;
    })(performance.now());
    barra(hasta);
  }

  /* La entrada recorre la vida de la edición: arranca en 100 y cae hasta
     lo que queda de verdad. No inventa nada —esas 84 se han vendido— pero
     hace que el dato se sienta vivo en vez de escrito en piedra. */
  cifra.textContent = quieto ? quedan : TOTAL;
  barra(quieto ? quedan : TOTAL);
  estado(quedan);

  var arrancado = false;
  var io3 = new IntersectionObserver(function(es){
    es.forEach(function(e){
      if (e.isIntersecting && !arrancado) {
        arrancado = true;
        io3.disconnect();
        setTimeout(function(){ contar(TOTAL, quedan, 900); }, 140);
      }
    });
  }, {threshold:.35});
  io3.observe(caja);

  /* Al volver a la pestaña se relee el stock del servidor. Si alguien ha
     comprado mientras tanto, la cifra baja delante de quien está mirando. */
  var ultimo = quedan, pidiendo = false, visto = Date.now();
  function refrescar(){
    if (pidiendo || Date.now() - visto < 20000) return;
    pidiendo = true; visto = Date.now();
    fetch(location.pathname + location.search, { credentials:'same-origin' })
      .then(function(r){ return r.ok ? r.text() : null; })
      .then(function(html){
        pidiendo = false;
        if (!html) return;
        var m = html.match(/vendidas:\s*(\d+)/);
        if (!m) return;
        var n = Math.max(0, TOTAL - parseInt(m[1], 10));
        if (n !== ultimo) {
          contar(ultimo, n, 900);
          ultimo = n;
          estado(n);
        }
      })
      .catch(function(){ pidiendo = false; });
  }
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible' && arrancado) refrescar();
  });
})();

function setLang(l){
  document.documentElement.lang=l;
  document.querySelectorAll('[data-'+l+']').forEach(function(e){e.innerHTML=e.getAttribute('data-'+l)});
  document.querySelectorAll('.lang button').forEach(function(b){b.classList.toggle('on',b.dataset.lang===l)});
  try{localStorage.setItem('mess-lang',l)}catch(e){}
}
document.querySelectorAll('.lang button').forEach(function(b){b.onclick=function(){setLang(b.dataset.lang)}});
try{if(localStorage.getItem('mess-lang')==='en')setLang('en')}catch(e){}

var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in');io.unobserve(e.target)}})},{threshold:.14});
document.querySelectorAll('.rv').forEach(function(e){io.observe(e)});

/* ---------- menú ---------- */
var menu = document.getElementById('menu');
var menubtn = document.getElementById('menubtn');
function abrirMenu(v){
  menu.classList.toggle('on', v);
  document.body.classList.toggle('menu-open', v);
  menubtn.setAttribute('aria-expanded', v ? 'true' : 'false');
  if (v) document.getElementById('menuclose').focus(); else menubtn.focus();
}
menubtn.addEventListener('click', function(){ abrirMenu(true); });
document.getElementById('menuclose').addEventListener('click', function(){ abrirMenu(false); });
document.addEventListener('keydown', function(e){ if(e.key==='Escape' && menu.classList.contains('on')) abrirMenu(false); });

/* ---------- galería deslizable + visor ---------- */
var track   = document.getElementById('track');
var slides  = track ? [].slice.call(track.querySelectorAll('.slide img')) : [];
var thumbs  = [].slice.call(document.querySelectorAll('.thumbs button'));
var viewer  = document.getElementById('viewer');
var viewerimg = document.getElementById('viewerimg');
var current = 0;

function marcar(i){
  current = i;
  thumbs.forEach(function(b,j){ b.classList.toggle('on', j===i); });
}
thumbs.forEach(function(b,i){
  b.onclick = function(){ track.scrollTo({left: i*track.clientWidth, behavior:'smooth'}); marcar(i); };
});
if (track) {
  var t;
  track.addEventListener('scroll', function(){
    clearTimeout(t);
    t = setTimeout(function(){
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i !== current) marcar(i);
    }, 90);
  }, {passive:true});
}

function openViewer(){
  if (!slides[current]) return;
  viewerimg.src = slides[current].dataset.full;
  viewerimg.alt = slides[current].alt;
  viewer.classList.add('on');
  document.body.style.overflow = 'hidden';
  document.getElementById('viewerclose').focus();
}
function closeViewer(){ viewer.classList.remove('on'); document.body.style.overflow=''; }
[].slice.call(document.querySelectorAll('.slide')).forEach(function(sl){ sl.addEventListener('click', openViewer); });
document.getElementById('viewerclose').addEventListener('click', function(e){ e.stopPropagation(); closeViewer(); });
viewer.addEventListener('click', closeViewer);
document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeViewer(); });

/* El selector de idioma sólo aparece cuando el póster ya ha pasado:
   flotando sobre él se cruzaba con las etiquetas del pie. */
function onScroll(){
  var poster = document.querySelector('.poster');
  var limite = poster ? poster.offsetTop + poster.offsetHeight - 90 : 40;
  document.body.classList.toggle('scrolled', window.scrollY > limite);
}
window.addEventListener('scroll',onScroll,{passive:true});
window.addEventListener('resize',onScroll,{passive:true}); onScroll();

/* El alta de correo la resuelve el formulario nativo de Shopify
   ({% form 'customer' %}): no hace falta JavaScript. */

/* --- barra fija de compra: entra cuando el boton principal sale de pantalla --- */
(function(){
  var bar = document.getElementById('buybar');
  var cta = document.getElementById('mainbuy');
  if (!bar || !cta) return;
  /* La edicion esta cerrada: el enlace de la barra lleva a la lista y manda
     el href que ya trae el marcado. Antes la barra disparaba el boton del
     panel; ahora ese boton envia un formulario, y dispararlo desde aqui
     mandaria un correo vacio. */
  var io2 = new IntersectionObserver(function(es){
    es.forEach(function(e){
      var ver = !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('on', ver);
      bar.setAttribute('aria-hidden', ver ? 'false' : 'true');
    });
  }, {threshold:0});
  io2.observe(cta);
})();

/* --- Un solo ejemplar por pedido --------------------------------------
   Antes, cada pulsacion sumaba una unidad mas: quien iba al pago con Apple
   Pay, volvia atras y pulsaba otra vez acababa con dos en el carrito y sin
   forma de quitarlas. Ahora se vacia el carrito antes de anadir, asi que
   volver atras nunca deja residuo. */
(function(){
  var f = document.getElementById('buyform');
  if (!f || !window.fetch) return;
  var campo = f.querySelector('input[name="id"]');
  if (!campo) return;
  var boton = document.getElementById('mainbuy');
  var enviando = false;

  /* El bloqueo dura solo lo que dura la peticion. Al volver con el boton
     atras el navegador restaura la pagina tal cual la dejaste, asi que hay
     que devolver el boton a su sitio o la compra queda muerta. */
  function bloquear(v){
    enviando = v;
    if (!boton) return;
    boton.disabled = v;
    boton.style.opacity = v ? '.6' : '';
  }
  function soltar(){ bloquear(false); }
  window.addEventListener('pageshow', soltar);
  window.addEventListener('focus', soltar);
  document.addEventListener('visibilitychange', function(){
    if (document.visibilityState === 'visible') soltar();
  });
  soltar();

  f.addEventListener('submit', function(ev){
    ev.preventDefault();
    if (enviando) return;
    bloquear(true);
    var fallo = setTimeout(soltar, 8000);   // red lenta: nunca se queda colgado
    fetch('/cart/clear.js', { method:'POST', credentials:'same-origin' })
      .then(function(){
        return fetch('/cart/add.js', {
          method:'POST', credentials:'same-origin',
          headers:{ 'Content-Type':'application/json' },
          body: JSON.stringify({ items:[{ id: campo.value, quantity: 1 }] })
        });
      })
      .then(function(){ clearTimeout(fallo); window.location.href = '/cart'; })
      .catch(function(){
        clearTimeout(fallo); soltar();
        HTMLFormElement.prototype.submit.call(f);
      });
  });
})();